import React from 'react';

import '@/components/badges/BadgeStyles.css';
import { LTTooltip } from '@/components/ui/LTTooltip';

type IdentityType = 'creator' | 'sovereign' | 'executioner' | 'verifier' | 'contributor' | 'observer';

const LABEL: Record<IdentityType, string> = {
  creator: 'Creator',
  sovereign: 'Sovereign Lead',
  executioner: 'Executioner',
  verifier: 'Verifier',
  contributor: 'Lateral Contributor',
  observer: 'Observer',
};

const ICON: Record<IdentityType, string> = {
  creator: '👑',
  sovereign: '🔱',
  executioner: '🛠️',
  verifier: '⚖️',
  contributor: '📡',
  observer: '👁️',
};

const TOOLTIP: Record<IdentityType, string> = {
  creator: '👑 Creator (Initiator): Started the project. Authority is governed by badges, not seniority.',
  sovereign: '🔱 Sovereign Lead (Owner): Owns the workstream lane(s) and is accountable for outcomes.',
  executioner: '🛠️ Executioner (Do-er): Executes tasks and delivers action items.',
  verifier: '⚖️ Verifier (Gatekeeper): Reviews and approves; controls sealing and truth gates.',
  contributor: '📡 Lateral Contributor: Provides cross-lane support and strategic help (Electric Blue).',
  observer: '👁️ Observer: Read-only visibility for context and alignment.',
};

export function IdentityBadge({ type }: { type: IdentityType }) {
  const text = LABEL[type] || String(type);
  const icon = ICON[type] || '🏷️';
  const tooltip = TOOLTIP[type] || text;

  const isElectric = type === 'contributor' || type === 'sovereign';
  const tone = type === 'creator' ? 'lt-badge--creator' : isElectric ? 'lt-badge--electric' : '';
  return (
    <LTTooltip content={tooltip}>
      <span className={`lt-badge ${tone}`} tabIndex={0}>
        <span className="lt-badge__icon" aria-hidden>
          {icon}
        </span>
        <span>{text}</span>
      </span>
    </LTTooltip>
  );
}

